





import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

import VueJsonPretty from "vue-json-pretty";
import { Applicant } from "../types";
import "vue-json-pretty/lib/styles.css";

const Applicants = namespace("applicant");
@Component({
  components: {
    "vue-json-pretty": VueJsonPretty,
  },
})
export default class DataPoints extends Vue {
  @Applicants.Getter("currentApplicant") applicant: Applicant;
}
